// import attributes from "./../Components/attributes";
import Edit from "./Edit";

const { registerBlockType } = wp.blocks;

import metadata from "./../../../blocks/youtube/block.json";

if (window.h5vpBlock?.isPipe || typeof window.h5vpBlock === "undefined") {
  registerBlockType(metadata, {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="682pt" height="682pt" viewBox="-21 -117 682.667 682">
        <path d="M626.813 64.035c-7.375-27.418-28.993-49.031-56.407-56.414C520.324-6.082 319.992-6.082 319.992-6.082s-200.324 0-250.406 13.184c-26.887 7.375-49.031 29.52-56.406 56.933C0 114.113 0 217.97 0 217.97s0 104.379 13.18 153.933c7.382 27.414 28.992 49.028 56.41 56.41C120.195 442.02 320 442.02 320 442.02s200.324 0 250.406-13.184c27.418-7.379 49.032-28.992 56.414-56.406 13.176-50.082 13.176-153.934 13.176-153.934s.527-104.383-13.183-154.46zM256.21 313.915V122.022l166.586 95.946zm0 0"></path>
      </svg>
    ),
    getEditWrapperProps: () => {},
    edit: Edit,
    save: () => {
      return null;
    },
    example: {
      attributes: true,
    },
  });
}
// import Edit from "./Edit";
